import React from "react";
import { Link } from 'react-router-dom';

function Info() {
  return (
    <>
      <div className="navbar">
        <div className="left">
          <Link to="/" className="logo-link">ArqueoJobs</Link>
        </div>
        <div className="right">
          <Link to="/enviar">Envía Oferta</Link>
          <Link to="/info">Info</Link>
          <Link to="/login">Login</Link>
        </div>
      </div>

      <div className="container">
        <h1>ℹ️ Información</h1>
        <p>
          Esta plataforma recopila y organiza ofertas de empleo arqueológico.
          Puedes filtrar por cronología, ubicación y categoría. También puedes
          enviar tus propias ofertas desde el formulario.
        </p>
      </div>
    </>
  );
}

export default Info;
